import React from "react"
import formatPrice from "@utils/formatPrice"
import { toLocaliseShopifyVariantData } from "@utils/toLocaliseShopifyData"

import * as s from "./ProductVariantSelector.module.scss"

export const ProductVariantSelector = ({
  variants,
  activeVariant,
  setVariant,
}) => {
  if (!variants || variants.length === 0) {
    return null
  }

  return (
    <div className={s.ProductVariant}>
      <div className={s.Variants}>
        {variants.map(variant => {
          const localisedVariantData = toLocaliseShopifyVariantData(variant)

          return (
            <div
              className={`${s.Variant} ${
                activeVariant.id === variant.id && s.Variant___active
              }`}
              key={variant.id}
              onClick={() => {
                setVariant(variant)
              }}
            >
              <span className={s.Variant__title}>
                {localisedVariantData.title}
              </span>
              <div>
                <span className={s.Variant__price}>
                  {formatPrice(
                    localisedVariantData.price,
                    localisedVariantData.priceCurrencyCode,
                  )}
                </span>
                <div className={s.Variant__bullet}>
                  <i className="fa fa-check" />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
